module.exports = __webpack_public_path__ + "img/poly-13.51eb696c.png";